import { Avatar, Divider, Paper } from "@material-ui/core";
import { FC, useEffect, useState } from "react";
import { ComponenteType, PedidoPagamento, PedidoType } from "src/types";
import { Formater, TypeRecords } from "src/framework/commons/Formater"
import "./styles.scss";
import { FullWidthButton } from "src/framework/components/buttons";
import { LocalStorage } from "src/framework/commons/LocalStorage";
import { CacheType } from "src/store/global.store";
import { confirmationDialog } from "src/framework/store";
import { BOLETO, BOLETO_CARTAO, BOLETO_FINANCIAMENTO, BOLETO_FINANCIAMENTO_INDIRETO, CARTAO_CREDITO, CARTAO_CREDITO_FINANCIAMENTO_INDIRETO, CARTAO_FINANCIAMENTO, FINAME, FINANCIAMENTO, FINANCIMENTO_INDIRETO, PIX, PIX_CARTAO, PIX_FINANCIAMENTO, PIX_FINANCIAMENTO_INDIRETO } from "src/constants";
import { useHistory } from "react-router-dom";
import { Alert } from "@material-ui/lab";
import { PagamentoListagemComponentes } from "../../PagamentoListagemComponentes";
import { parseCEP } from "src/framework/commons/masks";
import { PedidosProvider } from "src/providers/pagamentos/PedidoProvider";
import { STATUS_CODE } from "src/framework/providers/api";

type onChangeType = {
    pedido: PedidoType,
    pagamentoPedido: PedidoPagamento
}

interface ResumoProperties {
    pedido: PedidoType | undefined;
    pedidoPagamento: PedidoPagamento;
    disabled: boolean;
    onFinalizarPagamento: (pagamento: onChangeType) => void;
    onRemove: (newPagamento: PedidoPagamento) => void;
    onDisableFormasPagamento: (disabled: boolean) => void
}

const pedidosProvider = new PedidosProvider();

const Resumo: FC<ResumoProperties> = ({
    pedidoPagamento,
    pedido,
    disabled,
    onRemove,
    onFinalizarPagamento,
    onDisableFormasPagamento,
}) => {
    const history = useHistory();
    const hasPagamentos = () => pedidoPagamento.itens?.boletos?.length || pedidoPagamento.itens?.cartas_credito?.length || pedidoPagamento.itens?.cartoes_credito?.length || pedidoPagamento.itens?.financiamento?.length || pedidoPagamento.itens?.pix?.length

    const [disableConfirmation, setDisableConfirmation] = useState<boolean>(true);


    const pagamentoNaoConfirmado = (): number => {
        if (pedido) {

            switch (pedidoPagamento.forma_pagamento) {
                case CARTAO_CREDITO.id:
                    if (pedidoPagamento.itens?.cartoes_credito) {
                        const pagamentosCartao: number[] = pedidoPagamento.itens?.cartoes_credito.map((p) => p.valor_original);
                        let totalCartao = 0;
                        for (let t of pagamentosCartao) {
                            totalCartao += t;
                        }
                        return totalCartao
                    }
                    return 0;
                case BOLETO.id:
                    if (pedidoPagamento.itens?.boletos) {
                        const pagamentosBoleto: number[] = pedidoPagamento.itens?.boletos?.map((p) => p.valor) || [];
                        let totalBoleto = 0;
                        for (let t of pagamentosBoleto) {
                            totalBoleto += t;
                        }
                        return totalBoleto
                    }
                    return 0;
                case FINANCIMENTO_INDIRETO.id:
                    if (pedidoPagamento.itens?.cartas_credito) {
                        const pagamentosCarta: number[] = pedidoPagamento.itens?.cartas_credito.map((p) => p.valor);
                        let totalCarta = 0;
                        for (let t of pagamentosCarta) {
                            totalCarta += t;
                        }
                        return totalCarta
                    }
                    return 0;
                
                case FINAME.id:
                    if (pedidoPagamento.itens?.cartas_credito) {
                        const pagamentosCarta: number[] = pedidoPagamento.itens?.cartas_credito.map((p) => p.valor);
                        let totalCarta = 0;
                        for (let t of pagamentosCarta) {
                            totalCarta += t;
                        }
                        return totalCarta
                    }
                    return 0;

                case FINANCIAMENTO.id:
                    if (pedidoPagamento.itens?.financiamento) {
                        const pagamentosFinanciamento: number[] = pedidoPagamento.itens?.financiamento.map((p) => p.valor);
                        let totalFinanciamento = 0;
                        for (let t of pagamentosFinanciamento) {
                            totalFinanciamento += t;
                        }
                        return totalFinanciamento
                    }
                    return 0;
                case BOLETO_FINANCIAMENTO.id:
                    let totalBoletoFinanciamento = 0;
                    if (pedidoPagamento.itens?.financiamento) {
                        const pagamentosFinanciamento: number[] = pedidoPagamento.itens?.financiamento.map((p) => p.valor);
                        for (let t of pagamentosFinanciamento) {
                            totalBoletoFinanciamento += t;
                        }
                    }

                    if (pedidoPagamento.itens?.boletos) {
                        const pagamentosBoleto: number[] = pedidoPagamento.itens?.boletos?.map((p) => p.valor) || [];
                        for (let t of pagamentosBoleto) {
                            totalBoletoFinanciamento += t;
                        }
                    }
                    return totalBoletoFinanciamento;
                case BOLETO_FINANCIAMENTO_INDIRETO.id:
                    let totalBoletoCartaCredito = 0;
                    if (pedidoPagamento.itens?.cartas_credito) {
                        const pagamentosCarta: number[] = pedidoPagamento.itens?.cartas_credito.map((p) => p.valor);
                        for (let t of pagamentosCarta) {
                            totalBoletoCartaCredito += Number(t);
                        }
                    }
                    if (pedidoPagamento.itens?.boletos) {
                        const pagamentosBoleto: number[] = pedidoPagamento.itens?.boletos.map((p) => p.valor);
                        for (let t of pagamentosBoleto) {
                            totalBoletoCartaCredito += Number(t);
                        }
                    }

                    return totalBoletoCartaCredito;
                case BOLETO_CARTAO.id:
                    let totalBoletoCartao = 0;
                    if (pedidoPagamento.itens?.cartoes_credito) {
                        const pagamentosCarta: number[] = pedidoPagamento.itens?.cartoes_credito.map((p) => p.valor_original);
                        for (let t of pagamentosCarta) {
                            totalBoletoCartao += Number(t);
                        }
                    }
                    if (pedidoPagamento.itens?.boletos) {
                        const pagamentosBoleto: number[] = pedidoPagamento.itens?.boletos.map((p) => p.valor_original);
                        for (let t of pagamentosBoleto) {
                            totalBoletoCartao += Number(t);
                        }
                    }

                    return totalBoletoCartao;

                case PIX.id:
                    let totalPix = 0;
                    if (pedidoPagamento.itens?.pix) {
                        const pagamentosPix: number[] = pedidoPagamento.itens?.pix.map((p) => p.valor_original);
                        for (let t of pagamentosPix) {
                            totalPix += Number(t);
                        }
                    }

                    return totalPix;

                case PIX_CARTAO.id:
                    let totalPixCartao = 0;
                    if (pedidoPagamento.itens?.cartoes_credito) {
                        const pagamentosCarta: number[] = pedidoPagamento.itens?.cartoes_credito.map((p) => p.valor_original);
                        for (let t of pagamentosCarta) {
                            totalPixCartao += Number(t);
                        }
                    }
                    if (pedidoPagamento.itens?.pix) {
                        const pagamentosPix: number[] = pedidoPagamento.itens?.pix.map((p) => p.valor_original);
                        for (let t of pagamentosPix) {
                            totalPixCartao += Number(t);
                        }
                    }

                    return totalPixCartao;
                case PIX_FINANCIAMENTO.id:
                    let totalPixFinanciamento = 0;
                    if (pedidoPagamento.itens?.financiamento) {
                        const pagamentosFinanciamento: number[] = pedidoPagamento.itens?.financiamento.map((p) => p.valor);
                        for (let t of pagamentosFinanciamento) {
                            totalPixFinanciamento += t;
                        }
                    }
                    if (pedidoPagamento.itens?.pix) {
                        const pagamentosPix: number[] = pedidoPagamento.itens?.pix.map((p) => p.valor_original);
                        for (let t of pagamentosPix) {
                            totalPixFinanciamento += Number(t);
                        }
                    }

                    return totalPixFinanciamento;

                case PIX_FINANCIAMENTO_INDIRETO.id:
                    let totalPixCartaCredito = 0;
                    if (pedidoPagamento.itens?.cartas_credito) {
                        const pagamentosCarta: number[] = pedidoPagamento.itens?.cartas_credito.map((p) => p.valor);
                        for (let t of pagamentosCarta) {
                            totalPixCartaCredito += Number(t);
                        }
                    }
                    if (pedidoPagamento.itens?.pix) {
                        const pagamentosCarta: number[] = pedidoPagamento.itens?.pix.map((p) => p.valor_original);
                        for (let t of pagamentosCarta) {
                            totalPixCartaCredito += Number(t);
                        }
                    }

                    return totalPixCartaCredito;

                case CARTAO_CREDITO_FINANCIAMENTO_INDIRETO.id:
                    let totalCartaoCartaCredito = 0;
                    if (pedidoPagamento.itens?.cartas_credito) {
                        const pagamentosCarta: number[] = pedidoPagamento.itens?.cartas_credito.map((p) => p.valor);
                        for (let t of pagamentosCarta) {
                            totalCartaoCartaCredito += Number(t);
                        }
                    }
                    if (pedidoPagamento.itens?.cartoes_credito) {
                        const pagamentosCartoes: number[] = pedidoPagamento.itens?.cartoes_credito.map((p) => p.valor);
                        for (let t of pagamentosCartoes) {
                            totalCartaoCartaCredito += Number(t);
                        }
                    }

                    return totalCartaoCartaCredito;
                case CARTAO_FINANCIAMENTO.id:
                        let totalCartaoFinanciamento = 0;
                        if (pedidoPagamento.itens?.financiamento) {
                            const pagamentosFinanciamento: number[] = pedidoPagamento.itens?.financiamento.map((p) => p.valor);
                            for (let t of pagamentosFinanciamento) {
                                totalCartaoFinanciamento += t;
                            }
                        }
                        if (pedidoPagamento.itens?.cartoes_credito) {
                            const pagamentosCartoes: number[] = pedidoPagamento.itens?.cartoes_credito.map((p) => p.valor);
                            for (let t of pagamentosCartoes) {
                                totalCartaoFinanciamento += Number(t);
                            }
                        }
    
                        return totalCartaoFinanciamento;
    
                default:
                    return 0;
            }
        }
        return 0;
    }

    const preparePagamento = async () => {
        if (pedido) {
            const pedidoPagamentoState: PedidoPagamento = { ...pedidoPagamento }
            const pedidoState: PedidoType = { ...pedido }
            onFinalizarPagamento({ pedido: pedidoState, pagamentoPedido: pedidoPagamentoState })
        }
    }

    const removeBoletoCartaCredito = async (index: number, pagamentoPedido: PedidoPagamento) => {
        if (pagamentoPedido) {
            pagamentoPedido.itens?.cartas_credito?.splice(index, 1);
            pagamentoPedido.itens?.boletos?.splice(index, 1);
            pagamentoPedido.itens?.cartoes_credito?.splice(index, 1);

            onRemove(pagamentoPedido);
        }
    }

    useEffect(() => {
        if (pedido?.valor_pendente || pedido?.valor_pagamento) {
            const valorFormaPagamento: number = pagamentoNaoConfirmado();
            if (Number(valorFormaPagamento.toFixed(2)) >= Number((pedido?.valor_pendente || pedido?.valor_pagamento).toFixed(2))) {
                setDisableConfirmation(false);
                onDisableFormasPagamento(true)
            }
        }
    }, [pedidoPagamento]);

    return <div className="Resumo X12 S7 M3">
        <Paper className="paper" elevation={0}>
            <div className="row steps">
                <div className="X12">
                    <div className="step">
                        <Avatar>3</Avatar> Finalização da compra
                    </div>
                </div>
            </div>
            <div className="dados-gerais">
                <strong>Geral</strong>
                <Divider />
                {pedido?.codigo_venda && (<div className="info">
                    <div className="title">Código da venda</div>
                    <div className="value">{pedido.codigo_venda}</div>
                </div>)}
                {pedido?.potencia && <div className="info">
                    <div className="title">Potência do gerador</div>
                    <div className="value">{`${pedido?.potencia ? Formater.toString(pedido?.potencia || 0.0, TypeRecords.DECIMAL2) : 0} kWp`}</div>
                </div>}
                <div className="info">
                    <div className="title">Valor</div>
                    <div className="value">{`${Formater.toString(pedido?.valor_pagamento || 0, TypeRecords.CURRENCY)}`}</div>
                </div>
                <div className="info">
                    <div className="title">Valor de desconto (Cupom)</div>
                    <div className="value">{`${Formater.toString(pedido?.valor_desconto || 0, TypeRecords.CURRENCY)}`}</div>
                </div>
                <div className="info">
                    <div className="title">Valor a pagar</div>
                    <div className="value">{`${Formater.toString(pedido?.valor_pendente || 0, TypeRecords.CURRENCY)}`}</div>
                </div>
            </div>
            <div className="dados-gerais">
                <strong>Endereço de entrega</strong>
                <Divider />
                <div className="info">
                    <div className="title">{pedido?.endereco_entrega?.logradouro}, {pedido?.endereco_entrega?.numero}, {pedido?.endereco_entrega?.bairro}, {pedido?.endereco_entrega?.cidade}/{pedido?.endereco_entrega?.estado} - {parseCEP(String(pedido?.endereco_entrega?.cep))}</div>
                    <div className="value"></div>
                </div>
            </div>
            <div className="formas-pagamento">
                <strong>Forma de pagamento</strong>
                <Divider />

                {pedidoPagamento.itens?.boletos && pedidoPagamento.itens?.boletos?.length > 0 && (<>
                    <strong>Boleto</strong>
                    {pedidoPagamento.itens?.boletos.map((b, index) => {

                        return <>
                            <div className="item-pagamento" key={`item-pagamento-boletos-${index}`}>
                                <div className="index">{`#${index + 1}`}</div>
                                <div className="valor">{`${Formater.toString(b.valor, TypeRecords.CURRENCY)}`}</div>
                            </div>
                        </>
                    })}
                </>)}

                {pedidoPagamento.itens?.pix && pedidoPagamento.itens?.pix?.length > 0 && (<>
                    <strong>Pix</strong>
                    {pedidoPagamento.itens?.pix.map((b, index) => {

                        return <>
                            <div className="item-pagamento" key={`item-pagamento-pix-${index}`}>
                                <div className="index">{`#${index + 1}`}</div>
                                <div className="valor">{`${Formater.toString(b.valor, TypeRecords.CURRENCY)}`}</div>
                            </div>
                        </>
                    })}
                </>)}

                {pedidoPagamento.itens?.cartoes_credito && pedidoPagamento.itens?.cartoes_credito?.length > 0 && (<>
                    <strong>Cartão de crédito</strong>
                    {pedidoPagamento.itens?.cartoes_credito.map((c, index) => {
                        const parseBandeiraCartao = (bandeira: string): string => {
                            let _bandeira = bandeira;

                            switch (_bandeira) {
                                case "mastercard":
                                    return "Master Card"
                                case "visa":
                                    return "Visa"
                                case "amex":
                                    return "American Express"
                                case "jcb":
                                    return "JCB"
                                case "diners":
                                    return "Diners Club"
                            }

                            return _bandeira
                        }
                        return <>
                            <div className="item-pagamento" key={`item-pagamento-cartoes-${index}`}>
                                <div className="index">{`#${index + 1}`}</div>
                                <div className="valor">{`Cartão ${parseBandeiraCartao(c.bandeira)} final ${String(c.numero).slice(-4)} - ${c.parcelas} x ${Formater.toString(c.valor_parcela, TypeRecords.CURRENCY)}`}</div>
                            </div>
                        </>
                    })}
                </>)}

                {pedidoPagamento.itens?.cartas_credito && pedidoPagamento.itens?.cartas_credito?.length > 0 && (<>
                    <strong>{pedidoPagamento.forma_pagamento === FINAME.id ? "FINAME" : "Financiamento externo"}</strong>
                    {pedidoPagamento.itens?.cartas_credito.map((b, index) => {

                        return <>
                            <div className="item-pagamento" key={`item-pagamento-financiamento-indireto-${index}`}>
                                <div className="index">{`#${index + 1}`}</div>
                                <div className="valor">{`${Formater.toString(b.valor, TypeRecords.CURRENCY)}`}</div>
                            </div>
                        </>
                    })}
                </>)}

                {pedidoPagamento.itens?.financiamento && pedidoPagamento.itens?.financiamento?.length > 0 && (<>
                    <strong>Financiamento via plataforma</strong>
                    {pedidoPagamento.itens?.financiamento.map((b, index) => {

                        return <>
                            <div className="item-pagamento" key={`item-pagamento-financiamento-${index}`}>
                                <div className="index">{`#${index + 1}`}</div>
                                <div className="valor">{`${Formater.toString(b.valor, TypeRecords.CURRENCY)} | Entrada de ${Formater.toString(b.valor_entrada, TypeRecords.CURRENCY)} + ${b.parcelas}x de ${Formater.toString(b.valor_parcela, TypeRecords.CURRENCY)}`}</div>
                            </div>
                        </>
                    })}
                </>)}

                {!hasPagamentos() && <><div className="item-pagamento">
                    <div>Nenhuma forma de pagamento selecionada</div>
                </div></>}

            </div>
            <div>
                <div className="row">
                    
                    <div className="X12 S6">
                        <FullWidthButton
                            disabled={disableConfirmation || !hasPagamentos()}
                            text="Remover"
                            disableElevation
                            variant="contained"
                            onClick={async () => {
                                if (!pedido?.codigo_venda) return;
                                const substituicaoResult = await pedidosProvider.verificarSubstituicao(pedido.codigo_venda)
                                if (substituicaoResult.statusCode !== STATUS_CODE.OK) return

                                confirmationDialog.setup({
                                    title: "Aviso",
                                    content: "Confirmar remoção da(s) forma(s) de pagamento selecionada(s)?",
                                    onClose: () => {
                                        confirmationDialog.close();
                                    },
                                    onConfirmation: async () => {
                                        const state = { ...pedidoPagamento };
                                        state.itens.financiamento = [];
                                        state.itens.boletos = [];
                                        state.itens.cartas_credito = [];
                                        state.itens.cartoes_credito = [];
                                        state.itens.pix = [];
                                        onRemove(state)
                                        confirmationDialog.close();
                                    }
                                })
                                confirmationDialog.open()

                            }}
                        />
                    </div>
                   
                    <div className="X12 S6">
                        <FullWidthButton
                            disabled={disableConfirmation || !hasPagamentos()}
                            text="Finalizar compra"
                            color="primary"
                            disableElevation
                            variant="contained"
                            onClick={async () => {
                                if (!pedido?.codigo_venda) return;
                                const substituicaoResult = await pedidosProvider.verificarSubstituicao(pedido.codigo_venda)
                                if (substituicaoResult.statusCode !== STATUS_CODE.OK) return

                                confirmationDialog.setup({
                                    title: "Aviso",
                                    content: "Finalizar compra com esta forma de pagamento?",
                                    onClose: () => {
                                        confirmationDialog.close();
                                    },
                                    onConfirmation: async () => {
                                        preparePagamento();
                                    }
                                })
                                confirmationDialog.open()

                            }}
                        />
                    </div>
                    <div className="X12">
                        <Alert severity="warning" className="avisos">
                            Caso tenha esquecido o cupom ou precise editar os dados de cliente <a href="javascript:" onClick={() => {
                                history.push("/")
                            }}>clique aqui</a> para retornar a tela inicial
                        </Alert>
                    </div>
                </div>
            </div>
            <div className="itens">
                <PagamentoListagemComponentes itens={pedido?.itens} hidenDescription />
            </div>
        </Paper>
    </div>
}

export { Resumo }